module.exports = "https://web-assets.ifttt.com/packs/media/docs/landing_page_hue-e025d0e8.png";